/**
 * AsosService — STUB v1.12.485 (RapidAPI désactivé)
 */
export async function getAsosProducts() { return []; }
export async function searchAsosProducts() { return []; }
export async function getAsosProductDetail() { return null; }
